export enum FilterOperator {
    eq = 'eq',
    neq = 'neq',
    gte = 'gte',
    lte = 'lte',
    in = 'in',
    like = 'like'
}
